import React, { useEffect } from 'react';
import { CssBaseline, Box, Grid } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { setOnboardingComplete } from './redux/slices/currentUserSlice';
import { getFCMRegistrationToken } from './utils/getFCMRegistrationToken';
import { Notification } from './components';
import './index.css';

if (process.env.NODE_ENV === 'development') {
  import('./utils/devConsoleHelpers');
}

const App = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, isOnboardingComplete, employeeInfo } = useSelector((state) => state.currentUser);

  useEffect(() => {
    const onboardingStatus = localStorage.getItem('isOnboardingComplete');
    if (onboardingStatus) {
      dispatch(setOnboardingComplete());
    }
  }, [dispatch]);

  useEffect(() => {
    // Fire-and-forget: We do not await FCM registration, as notification setup is non-blocking for sign-in.
    if (employeeInfo) getFCMRegistrationToken(employeeInfo); // Request the token to receive notifications
  }, [employeeInfo]);

  return (
    <Router>
      <CssBaseline />
      <Grid container className={isAuthenticated && isOnboardingComplete ? 'non-login' : ''}>
        <Grid item xs={12} sm={isAuthenticated && isOnboardingComplete ? 9 : 12}>
          <Box className="main-content">
            <AppRoutes />
            <Notification />
          </Box>
        </Grid>
      </Grid>
    </Router>
  );
};

export default App;
